(ns ballot-scout-v2-frontend.embed-mockup.views
  (:require
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn page []
  (when @(rf/subscribe [::subs/admin?])
    (let [jurisdiction (rf/subscribe [::subs/current-jurisdiction])
          origin (.. js/window -location -origin)
          iframe-height (r/atom 1000)]
      (fn []
        [:div {:class "embed-mockup is-flex is-justify-content-center"}
         [:div {:class "content px-4"}
          [:div {:class "header is-flex is-align-items-center has-background-dark p-4"}
           [icon ::icon/jedi {:class "has-text-white is-flex is-align-items-center"}]
           [:div {:class "has-text-white mx-4"}
            [:h1 {:class "has-text-white is-size-2 my-0"} "DAGOBAH COUNTY, OUTER RIM"]
            [:div "Master Yoda, County Clerk"]]]
          [:div {:class "has-text-white p-3 is-size-7 is-flex is-justify-content-center has-background-info-dark"}
           "REGISTERED VOTERS AS OF" [:span {:class "pl-1 has-text-weight-bold"} "RETURN OF THE JEDI"]
           [:div {:class "mx-5"} [:span {:class "pr-1 has-text-weight-bold"} "TOTAL"] "3"]]
          [:div {:class "has-text-white p-3 my-4 has-background-info-dark"}
           "ABOUT" [:span {:class "mx-4"} "|"] "ELECTION INFO" [:span {:class "mx-4"} "|"]
           "FOR JEDI ☺ " [:span {:class "mx-4"} "|"] "FOR SITH ☹ "]
          [:div {:class "columns"}
           [:div {:class "column is-two-thirds"}
            [:div {:class "iframe-container has-background-white"}
             [:div {:class "is-size-3 mb-4 has-text-weight-bold has-text-link-dark"}
              "Check on my Vote By Mail Ballot"]
             [:iframe {:src (str origin "/" (:jurisdiction/slug @jurisdiction) "/search/admin")
                       :align "middle"
                       :style {:width "100%"
                               :height (-> @iframe-height (str "px"))}
                       :scrolling "no"
                       :marginWidth "0"
                       :marginHeight "0"
                       :frameBorder "0"
                       :vspace "0"
                       :title "Ballot Scout Widget"}]
             [:input {:class "input my-4"
                      :type "text"
                      :value @iframe-height
                      :placeholder "iframe height"
                      :on-change #(reset! iframe-height (-> % .-target .-value))}]]]
           [:div {:class "column is-one-third"}
            [:div {:class "control has-icons-right p-1 has-background-grey-light"}
             [:input {:class "input"
                      :type "text"
                      :placeholder "Search your feelings..."}]
             [:span {:class "icon is-small has-text-dark is-right"}
              [icon ::icon/search]]]
            [:div {:class "notifications-box message is-dark my-4"}
             [:div {:class "message-header has-text-weight-medium is-justify-content-center p-3"}
              "What's New"]
             [:div {:class "message-body"}
              [:ul
               [:li "Luke Skywalker has returned to his home planet of Tatooine in an attempt to rescue his friend Han Solo from the clutches of the vile gangster Jabba the Hutt."]
               [:li "Little does Luke know that the GALACTIC EMPIRE has secretly begun construction on a new armored space station even more powerful than the first dreaded Death Star."]
               [:li "When completed, this ultimate weapon will spell certain doom for the small band of rebels struggling to restore freedom to the galaxy..."]]]]]]]]))))